<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15vv5nW/images/cover.jpg?1685327317640" alt="This image is the cover for the book I Pledge Allegiance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Pledge Allegiance
      </h1>
      <p class="bookDescription body article font2">
        <p><i>What does it really mean for Christians to live as faithful kingdom citizens in today’s world?</i></p><p>Bitter partisan conflict. State-sanctioned torture. Economic injustice. Ethical corruption. Even a cursory glance over daily news headlines shows a stark contrast between the American political state and the kingdom of heaven. Where, then, does the Christian’s ultimate allegiance lie?</p><p>In <i>I Pledge Allegiance </i>David Crump issues a clarion call to Jesus’s twenty-first-century disciples, stirring them up to heed God's word and live out their kingdom citizenship here on earth. Closely examining the ethical teachings of Jesus and his apostles in the New Testament and using real-world examples to illustrate the vital issues at stake, Crump challenges Christians to embrace the radical, counterintuitive, upside-down way of Jesus—a way of living and thinking that turns the world’s values on their head, smashes through stale political and cultural conventions, and welcomes God’s kingdom into the very heart of our shared society. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Crump, Soong-Chan Rah
      </h2>
      
      <p class="authorDescription body article">David Crump is professor of religion at Calvin College,Grand Rapids, Michigan, and the author of Jesus theIntercessor: Prayer and Christology in Luke-Acts andKnocking on Heaven’s Door: A New TestamentTheology of Petitionary Prayer."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4598bbc